
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Get } from 'vuex-pathify';

import { FulfillmentType } from '../../../types/ProductDelivery';
import { ILocalStoreJson } from 'src/js/types/LocalStore';
import { IProductDetailProductJson } from '../../../types/PDP';

import ChangeStoreSideMenu from 'JS/components/side-menus/change-store/ChangeStoreSideMenu.vue';
import ExpandableZipArea from './ExpandableZipArea.vue';
import FulfillmentOptionLink from './FulfillmentOptionLink.vue';
import InStorePickup from './InStorePickup.vue';
import LocalDelivery from './LocalDelivery.vue';
import StandardShipping from './StandardShipping.vue';
import StockSubscriptionForm from './StockSubscriptionForm.vue';
import SubscriptionLearnMoreSlideout from 'JS/subscriptions/shared/components/SubscriptionLearnMoreSlideout.vue';
import SubscriptionOptions from './SubscriptionOptions.vue';
import { ProductSubscriptionStatus, SubscriptionResource } from 'JS/types/Order';

@Component({
	name: 'FulfillmentOptions',
	components: {
		ExpandableZipArea,
		LocalDelivery,
		InStorePickup,
		StandardShipping,
		ChangeStoreSideMenu,
		StockSubscriptionForm,
		FulfillmentOptionLink,
		SubscriptionLearnMoreSlideout,
		SubscriptionOptions,
	}
})
export default class FulfillmentOptions extends Vue {
	@Prop({ type: Boolean, required: false, default: false })
	readonly loading: boolean;

	/* Computed
	============================================*/

	@Get('product')
	readonly product: IProductDetailProductJson;

	@Get('localStore')
	readonly localStore: ILocalStoreJson;

	@Get('currentZip')
	readonly currentZip: string;

	@Get('selectedAttributes')
	readonly selectedAttributes: any[];

	@Get('customerEmail')
	readonly customerEmail: string | null;

	@Get('showTopLevelBackInStockForm')
	readonly showTopLevelBackInStockForm: boolean;

	@Get('fulfillmentType')
	readonly fulfillmentType: FulfillmentType;

	@Get('quantity')
	readonly quantity: number;

	get isLocalDeliveryAvailable(): boolean {
		return this.product.activeLocalDelivery && this.localStore?.localDeliveryInformation?.isEnabled;
	};

	get stockFormDescription(): string | null {
		if (!this.showTopLevelBackInStockForm) {
			return null;
		}

		const prefix = this.product.nearestInStock ? "Or, sign" : "Sign";
		return `${prefix} up to receive an email when this item is back in stock.`;
	}

	get showSubscriptionOptions(): boolean {
		return this.subscriptionInfo.status === ProductSubscriptionStatus.Eligible || this.subscriptionInfo.status === ProductSubscriptionStatus.Pending;
	}

	get subscriptionInfo(): SubscriptionResource {
		return this.product.subscriptionInfo;
	}

	/* Data
	============================================*/
	showZipArea: boolean = false;
	showSubscriptionDrawer = false;
	subscriptionFrequencySelection = "";
	showChangeStore = false;


	/* Methods
	============================================*/
	toggleZipArea() {
		this.showZipArea = !this.showZipArea;
	}

	handleStoreChanged() {
		if (typeof window !== 'undefined') {
			const url = `${window.location.origin}${window.location.pathname}?delivery=${this.fulfillmentType}`;
			window.history.replaceState({}, document.title, url);
			window.location.reload();
		}
	}

	setDeliveryType(type: FulfillmentType) {
		this.$store.dispatch('setDeliveryType', type);
	}

	openSubscriptionDrawer() {
		this.showSubscriptionDrawer = true;
	}

	closeSubscriptionDrawer() {
		this.showSubscriptionDrawer = false;
	}

	updateFrequencySelection(newVal: string) {
		this.subscriptionFrequencySelection = newVal;
		if (this.subscriptionInfo.status === ProductSubscriptionStatus.Eligible || this.subscriptionInfo.status === ProductSubscriptionStatus.Pending ) {
			this.$store.commit("subscriptionFrequency",  newVal !== "" ? parseInt(newVal) : null);
		}
	}

	@Watch('subscriptionInfo')
	onSubscriptionInfoChange(currentSubscriptionInfo: SubscriptionResource) {
		if (currentSubscriptionInfo.status !== ProductSubscriptionStatus.Eligible && currentSubscriptionInfo.status !== ProductSubscriptionStatus.Pending) {
			this.$store.commit("subscriptionFrequency", null);
		}
	}
}
